/**
 * 企业详情相关接口
 */
import { pbrAxios } from '../../common/js/pbrAxios'

/**
 * 企业详情页——基本信息接口
 *
 * @param {Object}params - 请求参数
 *    @param {String}params.from:en:英文  cn：中文  其他：中文
 *    @param {String}params.id:企业编号
 *    @param {String}params.userid:用户编号
 * @returns {AxiosPromise<any>}
 */
const queryEnterpriseDetail = params => {
  return pbrAxios.post('/front/enterprise/detail', params)
}


/**
 * 企业详情页——基本信息接口 by Name
 *
 * @param {Object}params - 请求参数
 *    @param {String}params.keywords： 企业名称
 * @returns {AxiosPromise<any>}
 */
const fetchEnterpriseByName = params => pbrAxios.post('/front/enterprise/getEnterpriseByName', params)


/**
 * 企业详情页——项目列表接口
 *
 * @param {Object}params - 请求参数
 *    @param {String}params.id:企业编号
 *    @param {String}params.currentpage:当前页
 *    @param {String}params.pagesize:每页行数
 * @returns {AxiosPromise<any>}
 */
const fetchEnterprisePInfos = params => {
  return pbrAxios.post('/front/enterprise/pinfos', params)
}

/**
 * 企业详情页——项目数据统计接口
 *
 * @param {Object}params - 请求参数
 *    @param {String}params.from:en:英文  cn：中文  其他：中文
 *    @param {String}params.id:企业编号
 * @returns {AxiosPromise<any>}
 */
const fetchEnterprisePStatistic = params => {
  return pbrAxios.post('/front/enterprise/pstatistic', params)
}

/**
 * 企业详情页——相关资讯接口
 *
 * @param {Object}params - 请求参数
 *    @param {String}params.from:en:英文  cn：中文  其他：中文
 *    @param {String}params.id:企业编号
 * @returns {AxiosPromise<any>}
 */
const fetchEnterpriseAInfo = params => {
  return pbrAxios.post('/front/enterprise/ainfos', params)
}



const getProjectByEnterprise = params => pbrAxios.post('/front/project/getProjectByEnterprise', params)


const fetchCompanyNewsList = params => pbrAxios.post('/front/article/companyNews/list', params)


 const relatedCompany = (params) => pbrAxios.post('/front/enterprise/glike',params)

export default {
  queryEnterpriseDetail,
  fetchEnterprisePInfos,
  fetchEnterprisePStatistic,
  fetchEnterpriseAInfo,
  fetchEnterpriseByName,
  getProjectByEnterprise,
  fetchCompanyNewsList
}
